import {
  Description as DescriptionIcon,
  Book as BookIcon,
  VolumeUp as VolumeUpIcon,
  Assignment as AssignmentIcon,
  Quiz as QuizIcon,
} from '@mui/icons-material';

export const EXERCISE_PART_TYPES = {
  description: {
    name: 'Lesson',
    icon: DescriptionIcon,
    color: 'primary',
    route: 'description',
  },
  vocabulary: {
    name: 'Vocabulary',
    icon: BookIcon,
    color: 'secondary',
    route: 'vocabulary',
  },
  lcExercise: {
    name: 'LC Exercise',
    icon: VolumeUpIcon,
    color: 'info',
    route: 'lc-exercise',
  },
  rcExercise: {
    name: 'RC Exercise',
    icon: AssignmentIcon,
    color: 'success',
    route: 'rc-exercise',
  },
  attendanceTest: {
    name: 'Attendance Test',
    icon: QuizIcon,
    color: 'warning',
    route: 'test',
  },
};